import { useUpdateAtom, useAtomCallback } from "jotai/utils"
import { BaseRecord } from "./types"
import { useCellStore } from "./TableScope"
import { actionsAtom, getRowById } from "./atoms"
import { useCallback } from "react"

type Entries = [string, any][]

export function useRow<R extends BaseRecord>(rowId: string) {
  const store = useCellStore()
  const actions = useUpdateAtom(actionsAtom)

  const getRow = useAtomCallback<{ initial: R; cells: Entries }, string>(
    useCallback(
      (get, _, rowId) => {
        const initial = getRowById<R>(get, rowId)
        const cells = store.getRowCells(get, rowId)
        return { initial, cells }
      },
      [store],
    ),
  )

  const removeRow = (): void => {
    actions({ type: "remove_record", pld: { rowId } })
  }

  const getRowInfo = (rowId: string) => {
    return getRow(rowId)
  }

  return {
    removeRow,
    getRowInfo,
  }
}
